import { SharedApiV2 } from "@capstone/mock-api";
import { UUID } from "src/utils";

type ApiSite = SharedApiV2.EnterpriseSiteDTO;

export class CapstoneSite {
  public constructor(args: ClassProperties<CapstoneSite>) {
    this.name = args.name;
    this.masterPartnerId = args.masterPartnerId;
    this.number = args.number;
  }

  public readonly name: string;
  public readonly masterPartnerId: number;
  public readonly number: number;

  public static deserialize(data: ApiSite): CapstoneSite {
    return new CapstoneSite({
      name: data.siteName,
      masterPartnerId: data.masterPartnerId,
      number: data.masterSiteId,
    });
  }

  public static deserializeList(value: ApiSite[]): readonly CapstoneSite[] {
    return value.map((x) => CapstoneSite.deserialize(x));
  }
}

type ApiPartner = SharedApiV2.EnterprisePartnerDto;

export class CapstonePartner {
  private constructor(args: ClassProperties<CapstonePartner>) {
    this.key = args.key;
    this.masterId = args.masterId;
    this.name = args.name;
  }

  public readonly key: UUID;
  public readonly masterId: number;
  public readonly name: string;

  public static deserialize(data: ApiPartner): CapstonePartner {
    return new CapstonePartner({
      key: new UUID(data.partnerKey),
      masterId: data.masterPartnerId,
      name: data.partnerName,
    });
  }

  public static deserializeList(
    value: ApiPartner[],
  ): readonly CapstonePartner[] {
    return value.map((item) => CapstonePartner.deserialize(item));
  }
}
